import { render } from "./roleManage.vue?vue&type=template&id=54076465"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"

import "./roleManage.vue?vue&type=style&index=0&id=54076465&lang=scss"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__